import { Helmet } from "react-helmet";
import { Header } from "@/components/layout/Header";
import { BusinessHero, HowItWorks, StoreExamplesSection, GrowthCopilotSection, BusinessPillars, BusinessEntryPaths, MarketingGrowthSection, BusinessPricing, BusinessFAQAndCTA } from "@/components/home/BusinessHomeSections";
import { SocialProofSection } from "@/components/home/SocialProofSection";
import { Footer } from "@/components/Footer";
import "@/components/home/business-home.css";

export default function Home() {
  return (
    <div className="business-home min-h-screen">
      <Helmet>
        <title>Sokoby — Lancez votre business avec l’IA</title>
        <meta name="description" content="Créez votre boutique avec Sokoby, préparez vos produits et votre marketing avec l’IA, et développez votre business." />
        <meta property="og:title" content="Sokoby — Lancez votre business avec l’IA" />
        <meta property="og:description" content="De l’idée à la boutique, du marketing à la croissance : construisez votre business avec Sokoby." />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <link rel="stylesheet" href="https://fonts.googleapis.com/css2?family=Sora:wght@400;500;600;700&family=Manrope:wght@400;500;600;700&display=swap" />
      </Helmet>
      <Header officialLogo />
      <main>
        <BusinessHero />
        <HowItWorks />
        <StoreExamplesSection />
        <GrowthCopilotSection />
        <BusinessPillars />
        <BusinessEntryPaths />
        <MarketingGrowthSection />
        <div className="home-proof"><SocialProofSection /></div>
        <BusinessPricing />
        <BusinessFAQAndCTA />
      </main>
      <Footer />
    </div>
  );
}
